/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * The text used in release notes links that point back to the table of contents in the document.
 */
export const RELEASE_NOTES_TOC_LINK_TEXT = "⬆️ Table of contents";
